import React from 'react';
import Slider from '@material-ui/core/Slider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import IntlMessages from 'util/IntlMessages';

function valuetext(value) {
    return `${value}`;
}

function ImageHeightSetting(props) {
    
    const handleChange = (event, newValue) => {
        props.setImageHeight(newValue)
    };
    return (
        <Grid item xs="12">
            <Typography id="discrete-slider" gutterBottom>
                <IntlMessages id="Label.Image.Size"/>
            </Typography> 
            <Slider
            value={props.ImageHeight}
            getAriaValueText={valuetext}
            aria-labelledby="discrete-slider"
            valueLabelDisplay="auto"
            step={10}
            onChange={handleChange}
            marks
            min={10}
            max={110}
            />
        </Grid>
    );
}

export default ImageHeightSetting;